export const SIDEBAR_PUBLICATION_PRICE_MAP = "sidebar publication price map";
export const SIDEBAR_PUBLICATION_PRICE_CALCULATIONS =
  "sidebar publication price calculations";
export const SIDEBAR_PUBLICATION_PRICE_SUMMARY =
  "sidebar publication price summary";
